var palette = {
    blue: {
        lightest: '#DCECF9',
        lighter: '#97C5F0',
        light: '#4F9DE7',
        main: '#0070DD',
        dark: '#00509F',
        darker: '#003365',
    },
    red: {
        lightest: '#F9E2E2',
        lighter: '#F7ADA5',
        light: '#EB776C',
        main: '#D93737',
        dark: '#9C2828',
        darker: '#631919',
    },
    orange: {
        lightest: '#FDE6CE',
        lighter: '#FFC998',
        light: '#FEAC5F',
        main: '#F07D00',
        dark: '#B35F13',
        darker: '#743208',
    },
    yellow: {
        lightest: '#FFF5C7',
        lighter: '#FFE597',
        light: '#FFD462',
        main: '#FFC208',
        dark: '#B78707',
        darker: '#6B4A06',
    },
    green: {
        lightest: '#D7EFDF',
        lighter: '#A5D8AA',
        light: '#71C077',
        main: '#2EA843',
        dark: '#227934',
        darker: '#154D26',
    },
    neem: {
        lightest: '#D7EFDF',
        lighter: '#A5D8AA',
        light: '#71C077',
        main: '#2EA843',
        dark: '#227934',
        darker: '#154D26',
    },
    neel: {
        lightest: '#E2E5F9',
        lighter: '#ABB4ED',
        light: '#7583E1',
        main: '#3D51D4',
        dark: '#2C3A98',
        darker: '#1C2561',
    },
    nimbu: {
        lightest: '#E3F3CE',
        lighter: '#C6E599',
        light: '#A6D763',
        main: '#82C91E',
        dark: '#578715',
        darker: '#304A0B',
    },
    jamun: {
        lightest: '#E0D8EE',
        lighter: '#BFAADA',
        light: '#9D7EC6',
        main: '#7A53B2',
        dark: '#644491',
        darker: '#4E3572',
    },
    tawak: {
        lightest: '#FDE6CE',
        lighter: '#FFC998',
        light: '#FEAC5F',
        main: '#F07D00',
        dark: '#B35F13',
        darker: '#743207',
    },
    stone: {
        lightest: '#F4F4F4',
        lighter: '#ECECEC',
        light: '#E5E5E5',
        main: '#D5D5D5',
        dark: '#C5C5C5',
    },
    night: {
        lightest: '#A6A6A6',
        lighter: '#868686',
        light: '#595959',
        main: '#2F2F2F',
    },
    neutral: {
        lightest: '#8C8E97',
        lighter: '#666975',
        light: '#404353',
        main: '#2F2F2F',
    },
    black: {
        main: '#000000',
    },
    white: {
        main: '#FFFFFF',
    },
};
export default palette;
//# sourceMappingURL=palette.js.map